var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPepiconsPencilBankCircleFilled = function SvgPepiconsPencilBankCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pepicons-pencil_bank-circle-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pepicons-pencil_bank-circle-filled_svg__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16 6.993-7.46 4.7h14.922zm.33-1.248a.62.62 0 0 0-.657 0L6.08 11.787c-.521.329-.289 1.136.329 1.136h19.185c.618 0 .85-.807.329-1.136zM6.153 24.615A.615.615 0 0 1 6.77 24H25.23a.615.615 0 1 1 0 1.23H6.77a.615.615 0 0 1-.616-.615m1.847-10.461a.615.615 0 0 1 .615.615v7.385a.615.615 0 0 1-1.23 0v-7.385A.615.615 0 0 1 8 14.154m3.692 0a.615.615 0 0 1 .615.615v7.385a.615.615 0 0 1-1.23 0v-7.385a.615.615 0 0 1 .615-.615m3.692 0a.615.615 0 0 1 .616.615v7.385a.615.615 0 0 1-1.231 0v-7.385a.615.615 0 0 1 .615-.615m3.693 0a.615.615 0 0 1 .615.615v7.385a.615.615 0 1 1-1.23 0v-7.385a.615.615 0 0 1 .614-.615m3.692 0a.616.616 0 0 1 .615.615v7.385a.615.615 0 1 1-1.23 0v-7.385a.615.615 0 0 1 .615-.615",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pepicons-pencil_bank-circle-filled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pepicons-pencil_bank-circle-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgPepiconsPencilBankCircleFilled;